import React from 'react'
import classNames from 'classnames'
import styles from './MarketingPageSection.module.css'

type Props = {
  children?: React.ReactNode
  className?: string
  id?: string
  isCentered?: boolean
  isClipped?: boolean
  isFullViewport?: boolean
  isHero?: boolean
  isTinted?: boolean
}

const MarketingPageSection = ({
  children,
  className,
  id,
  isCentered,
  isClipped,
  isFullViewport,
  isHero,
  isTinted
}: Props) => (
  <section
    id={id}
    className={classNames(
      styles.section,
      {
        [styles.isCentered]: isCentered,
        [styles.isClipped]: isClipped,
        [styles.isFullViewport]: isFullViewport,
        [styles.isHero]: isHero,
        [styles.isTinted]: isTinted
      },
      className
    )}>
    {children}
  </section>
)

export default MarketingPageSection
